<script>
  /* Executable code section of the program */
  // Components importation
  import EmptyTable from "../../components/EmptySections/EmptyTable.svelte";
  //Tool importation
  import {
    isUpdateTableModal,
    objData,
    isCustomTableModalOn,
    indexPositionData,
    invitedAttendeesArray,
    isAlertOn,
    alertMessagge,
    isConfirmModalOn,
    confirmResponse,
    isReloadNecessary,
    confirmDeleteCustomTable
  } from "../../apis/storage";
  import {
    getPaginatedDocuments,
    deleteNetworkingBreak,
    deleteCustomElements
  } from "../../apis/APIS";
  import { onMount } from "svelte";
  import DeleteCtModal from "../../components/Modals/DeleteCTModal.svelte";

  //Auxiliary variables
  export let currentEvent;
  let attendeeCustomTable = []
  $: dinamicTablesData = currentEvent.customTables;
  let lastDocument = null;
  let reservDocument = [];
  let eventsArray = [];
  let totalEventsArray = [];
  let isArrayComplete = false;
  let index = 0;
  let totalDocuments = 5;
  let buttonSelected = {}

  // Definition of the window witdh
  let windowWidth = window.innerWidth;

  //function to display custom table modal
  const displayCustomTableModal = () => {
    $isCustomTableModalOn = true;
    $invitedAttendeesArray = []
  };

  //Function to update a document
  const toUpdateDocument = (data,index) => {
    $isUpdateTableModal = true;
    $objData = data;
    $indexPositionData = index
  };

  
  //Function to display alert
  const displayAlert = () =>{
    $isAlertOn = true
  }

    //Function to display confirm modal
    const displayConfirmModal = (id,index) =>{
    buttonSelected = {data:id,indexObj:index}
    $confirmDeleteCustomTable = true
    $alertMessagge = "Are you sure you want to delete this custom table?"
  }

  //Function to delete networking break
  const toDeleteDocuments = () => {
    let currentTable =currentEvent.customTables[buttonSelected.indexObj]
    if ($confirmResponse) {
      
      currentEvent.customTables = 
        currentEvent.customTables.filter((customTable) => {  
          return customTable.id !== currentTable.id
        }
      );

      currentTable.attendeesAuthorized.map(element =>{
        attendeeCustomTable.push({id:element.id,fieldName:"customTables",values:[{id:currentTable.id,tableName:currentTable.tableTittle}]})
      })
      
      
      deleteNetworkingBreak("events", currentEvent, currentEvent.id, "Custom table")
      .then(()=>{
        deleteCustomElements("users",attendeeCustomTable)
        .then(() => {
          $confirmDeleteCustomTable = false
          $alertMessagge = "Custom table has been deleted successfully."; 
          $isReloadNecessary = true 
          displayAlert();
        })
      })
      .catch(()=> {
        $confirmDeleteCustomTable = false
        $alertMessagge = "The custom table could not be deleted."
        displayAlert()
      })
    }
  };
  //Function to get documents and create pagination
  const nextPageData = async () => {
    if (!isArrayComplete) {
      const { documents, lastDoc } = await getPaginatedDocuments(
        "customTables",
        currentEvent.tittle,
        totalDocuments,
        lastDocument
      );
      if (documents.length === 0) {
        isArrayComplete = true;
      }

      if (documents.length > 0) {
        if (
          !totalEventsArray.some(
            (obj) => JSON.stringify(obj) === JSON.stringify(documents[0])
          ) &&
          !isArrayComplete
        ) {
          totalEventsArray.push(documents);
          dinamicTablesData = documents;
          lastDocument = lastDoc;
          reservDocument.push(lastDoc);
          index++;
        }
      }
    } else {
      if (index < totalEventsArray.length - 1) {
        index++;
      }
      dinamicTablesData = totalEventsArray[index];
    }
  };

  const prevPageData = async () => {
    if (index >= 1) {
      index--;
      if (!isArrayComplete) {
        lastDocument = reservDocument[index];
      }
      dinamicTablesData = totalEventsArray[index];
    }
  };

  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    //fetch documents
    const { documents, lastDoc } = await getPaginatedDocuments(
      "customTables",
      currentEvent.tittle,
      totalDocuments,
      lastDocument
    );
    totalEventsArray.push(documents);
    eventsArray = documents;
    dinamicTablesData = eventsArray;
    lastDocument = lastDoc;
    reservDocument.push(lastDoc);
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<body>
  <div class="headerContent">
    <button class="btnAddEvent" on:click={displayCustomTableModal}
      >Add Custom Table</button
    >
  </div>
  <div class="listContainer">
    {#if currentEvent.customTables.length > 0}
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Table Name</th>
            <th scope="col">#Attendees</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {#each currentEvent.customTables as data, index}
            <tr>
              <th scope="row">{index + 1}</th>

              <td>{data.tableTittle || "N/A"}</td>
              <td>{data.attendeesAuthorized.length}</td>
              <td class="actionsBtn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-pencil-square icon"
                  viewBox="0 0 16 16"
                  on:keypress={() => toUpdateDocument(data, index)}
                  on:click={() => toUpdateDocument(data, index)}
                >
                  <path
                    d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-trash3-fill icon"
                  viewBox="0 0 16 16"
                  on:keypress={() => displayConfirmModal(data.id,index)}
                  on:click={() => displayConfirmModal(data.id,index)}
                >
                  <path
                    d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"
                  />
                </svg>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {:else}
      <EmptyTable />
    {/if}
  </div>
  {#if currentEvent.customTables.length > totalDocuments}
  <div class="paginationBtns">
    <button class="actionButton filterBtn" on:click={prevPageData}
      >Previous page</button
    >
    <button class="actionButton filterBtn" on:click={nextPageData}
      >Next page</button
    >
  </div>
  {/if}
</body>
{#if $confirmDeleteCustomTable}
  <DeleteCtModal callbackFunction ={toDeleteDocuments}/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */ 
    body {
      width: 100%;
      height: auto;
      max-height: 80vh;
      overflow: auto;
      padding: 50px 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
    } 
  .btnAddEvent {
    width: 250px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
  }

  .btnAddEvent:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .headerContent {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    padding: 20px;
  }
  .listContainer {
    background-color: white;
    width: 70%;
    height: auto;
    padding: 30px;
  }
  .actionsBtn {
    text-align: left;
  }
  .filterBtn {
    height: 40px;
    width: 100px;
  }
  .icon:hover {
    cursor: pointer;
    color: #ed2824;
  }
  .actionButton {
    width: 200px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
  }

  .actionButton:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .paginationBtns {
    width: 100%;
    height: auto;
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    body {
      width: 100%;
      height: auto;
      max-height: 100%;
      padding: 50px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .headerContent {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .listContainer {
      background-color: white;
      height: auto;
      margin: 0;
      padding: 20px;
      max-height: 30vh;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    body {
      background-color: #f4f4f4;
      width: 100%;
      min-height: 89vh;
      height: auto;
      padding: 50px 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .headerContent {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .listContainer {
      width: 100%;
      background-color: white;
      height: auto;
      margin: 0;
      padding: 0;
      max-height: 30vh;
    }
  }

  /* End of the section */
</style>
